function renderKlaviyoReviewsWidgets() {
  if (typeof window !== 'undefined') {
    window.klReviewsObject?.renderWidgets?.()
  }
}

export { renderKlaviyoReviewsWidgets }
